import Modal from "../ui/Modal";
import "./UpgradeModal.css";

interface SubscribedModalProps {
    open: boolean;
    onClose: () => void;
}

/**
 * Shown at /learn/thank-you — the page Stripe's checkout success_url points
 * at, so it works as a real URL rather than only ever being reachable from
 * in-app state. Reuses UpgradeModal's gradient treatment so it reads as the
 * same "you're on Plus now" moment instead of a generic dialog.
 */
export default function SubscribedModal({ open, onClose }: SubscribedModalProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title="You're all set!"
            panelClassName="upgrade-modal"
            actionLabel="Start learning"
            onAction={onClose}
        >
            <div className="upgrade-modal__badge">Eolass Plus</div>
            <p>
                Thanks for subscribing — you've got unlimited trees, unlimited problems,
                and no more daily limits.
            </p>
        </Modal>
    );
}
